import React from 'react';
import { trackCtaClick, withAnalyticsParams } from '../lib/analytics';
type WaitlistCTAProps = {
  children: React.ReactNode;
  className?: string;
  to?: string;
  ariaLabel?: string;
  // Kept for backwards compatibility with existing props
  spinnerClassName?: string;
  // GA4 analytics label — identifies where this CTA lives on the page
  // (e.g. "hero", "nav", "closing", "pricing").
  analyticsLabel?: string;
};
export function WaitlistCTA({
  children,
  className = '',
  to = 'https://app.getgiga.com/signup',
  ariaLabel,
  analyticsLabel
}: WaitlistCTAProps) {
  const handleClick = () => {
    const text = typeof children === 'string' ? children : undefined;
    trackCtaClick(analyticsLabel || 'waitlist-cta', text);
  };
  return <a href={withAnalyticsParams(to)} onClick={handleClick} aria-label={ariaLabel} className={`relative inline-block text-center ${className}`} data-id="element-5877" data-mp="11h0b6t6g9znc">
      
      <span className="inline-flex items-center justify-center gap-2" data-id="element-5878" data-mp="338d4ekz22j3k">
        {children}
      </span>
    </a>;
}